module.exports = __webpack_public_path__ + "img/20.3a15adb3.png";